import { Ctx, Query, Resolver, UseMiddleware } from "type-graphql";
import Session from "../../shared/models/session";
import Context from "../models/context";
import AuthorizationMiddleware from "../middlewares/authorization-middleware";
import HandledPromise from "../models/handled-promise";

/** Resolver for sessions */
@Resolver(Session)
export default class SessionResolver {
    /** Gets the session */
    @Query(() => Session)
    @UseMiddleware(AuthorizationMiddleware)
    public async getSession(
        @Ctx() context: Context
    ) {
        global.executions.addLine({className: "SessionResolver",functionName: "getSession",hierarchy: ["/backend/resolvers/session-resolver.ts", "SessionResolver", "getSession"],fileName: "/backend/resolvers/session-resolver.ts",childLine: 16,line: "        return HandledPromise<Session>(async (res, rej) => {"});
        return HandledPromise<Session>(async (res, rej) => {
            global.executions.addLine({className: "SessionResolver",functionName: "[anonymous]",hierarchy: ["/backend/resolvers/session-resolver.ts", "SessionResolver", "getSession", "[anonymous]"],fileName: "/backend/resolvers/session-resolver.ts",childLine: 17,line: "            return res(context.session!)"});
            return res(context.session!)
        })
    }
}